import React from 'react';
import { useStore } from '../../../store/store-provider';
import Modal from '../../shared/modal/modal';
import { POLLS_LIST_LIMIT_MESSAGE } from '../../../constans/polls-constants';
import { ModalTexts, ModalTypes } from '../../../constans/modal.constants';
import { observer } from 'mobx-react';
import { getMixpanelService } from '../../../utils/services/mixpanel-service-instance';
import { MIXPANEL_EVENT_IDENTIFIERS, MIXPANEL_EVENT_TYPES } from '../../../constans/mixpanel-contants';

interface IProps {
    isPollListLimitExceeded: boolean;
}

const ContainerModalManager: React.FC<IProps> = ({
  isPollListLimitExceeded
}) => {
  const { pollsStore, podiumInfoStore } = useStore();
  const { presentationInfo: { presentationName }, getPresentationId } = podiumInfoStore;
  const {
    shouldShowNotificationModal,
    hideNotificationModal,
    shouldShowDeleteModal,
    shouldShowResetModal,
    shouldShowAddResultsSlideModal,
    setShouldShowAddResultsSlideModal,
    setShouldShowDeleteModal,
    setShouldShowResetModal,
    deletePoll,
    resetPoll,
    clearErrorMessage,
    getPollEntityById,
    generatePollResultsSlide,
  } = pollsStore;

  const deletePollHandler = async (): Promise<void> => {
    setShouldShowDeleteModal(false);
    await deletePoll();
  };

  const closeDeleteModal = (): void => {
    setShouldShowDeleteModal(false);
  };

  const resetPollHandler = async (): Promise<void> => {
    setShouldShowResetModal(false);
    const targetEntity = pollsStore.getPollEntityById(pollsStore.selectedPollId);

    await resetPoll(targetEntity);
    getMixpanelService().track(MIXPANEL_EVENT_IDENTIFIERS.POLLS, MIXPANEL_EVENT_TYPES.RESET_CONFIRMED);
  };

  const closeResetModal = (): void => {
    setShouldShowResetModal(false);
  };

  const addResultSlideHandler = async (): Promise<void> => {
    setShouldShowAddResultsSlideModal(false);
    const targetEntity = getPollEntityById(pollsStore.selectedPollId);
    const updateRequestBody = {
      result_slide_added: true,
      pollId: targetEntity.getId(),
    };
    const presentationId = +getPresentationId()!;
    const pollDataRequestBody = targetEntity.getPollSlideGenerateData(presentationName, presentationId);
    targetEntity.updateIsShowGenerating(true);

    await generatePollResultsSlide(pollDataRequestBody, updateRequestBody);

    targetEntity.updateIsShowGenerating(false);
  };

  const closeAddResultsSlideModal = (): void => {
    setShouldShowAddResultsSlideModal(false);
  };

  const closeHideNotificationModalHandler = (): void => {
    hideNotificationModal();
    getMixpanelService().track(MIXPANEL_EVENT_IDENTIFIERS.POLLS, MIXPANEL_EVENT_TYPES.ERROR_MAX_POLLS);
  };

  return (
    <>
      {isPollListLimitExceeded && shouldShowNotificationModal
        ? <Modal
          cancelAction={closeHideNotificationModalHandler}
          modalType={ModalTypes.NOTIFICATION}
          htmlString={POLLS_LIST_LIMIT_MESSAGE}
          />
        : null
      }
      {shouldShowDeleteModal &&
        <Modal
          doneAction={deletePollHandler}
          cancelAction={closeDeleteModal}
          modalType={ModalTypes.CONFIRMATION}
          bodyText={ModalTexts.DELETE_POLL_MESSAGE}
          doneButtonText={ModalTexts.DELETE_POLL_DONE_TEXT}
        />
      }
      {shouldShowResetModal &&
        <Modal
          doneAction={resetPollHandler}
          cancelAction={closeResetModal}
          modalType={ModalTypes.CONFIRMATION}
          bodyText={ModalTexts.RESET_POLL_MESSAGE}
          doneButtonText={ModalTexts.RESET_POLL_DONE_TEXT}
        />
      }
      {shouldShowAddResultsSlideModal &&
        <Modal
          doneAction={addResultSlideHandler}
          cancelAction={closeAddResultsSlideModal}
          modalType={ModalTypes.CONFIRMATION}
          bodyText={ModalTexts.ADD_RESULTS_SLIDE_MESSAGE}
          doneButtonText={ModalTexts.ADD_RESULTS_SLIDE_DONE_TEXT}
        />
      }

      {pollsStore.errorMessage &&
        <Modal
          cancelAction={clearErrorMessage}
          modalType={ModalTypes.ERROR}
          bodyText={pollsStore.errorMessage}
        />
      }
    </>
  );
};

export default observer(ContainerModalManager);
